import { render, staticRenderFns } from "./BusinessThankYou.vue?vue&type=template&id=0731a514"
import script from "./BusinessThankYou.vue?vue&type=script&lang=js"
export * from "./BusinessThankYou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports